<template>
    <div class="home">
        <b-container fluid>
            <b-row>
              <b-col>
                <h1>Change License Expiration Date</h1>
                <h2 class="danger">This should only be used for testing purposes!</h2>
              </b-col>
            </b-row>

            <div class="card">
              <div class="card-header">License to Update</div>
              <div class="card-body">   

                <b-row>
                  <b-col cols="4">
                    <BaseTextInput v-model="licenseNumber" 
                                          :v="$v.licenseNumber"
                                          label="License Number"
                                          slug="licenseNumber"/>
                  </b-col>
                  <b-col cols="4">
                     <b-form-datepicker 
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                            v-model="expiryDate">
                        </b-form-datepicker>
                  </b-col>
                  <b-col>                                          
                    <b-button variant="danger" class="mr-3" style="margin-top:32px;" @click="submit">Submit</b-button>
                  </b-col>
                </b-row>
    
              </div>
            </div>

        </b-container>

    </div>
</template>

<script>
import axios from 'axios'
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
  components: {
  },

  data: () => ({
    licenseNumber: null,
    expiryDate: null,
  }),
  
  mounted() {
  },

  validations: {
    licenseNumber: { required, maxLength: maxLength(10) }
  },

  computed: {
  },

  methods: {

    submit() {
      const payload = {
        licenseNumber: this.licenseNumber,
        expiryDate: this.expiryDate
      }

      axios.post(`${process.env.VUE_APP_API_BASE_URL}/license/override`, payload)
        .then(response => { 
           this.showRootToast("License Updated", "The license expiration date has been updated.", "success")
           this.$router.push('/home')
        })
    },

    showRootToast(title, message, type) {
      this.$root.$bvToast.toast(message, {
            title: title,
            toaster: 'b-toaster-top-center',
            solid: true,
            variant: type,
            appendToast: true,
            noAutoHide:true
          })
        this.toastFocus()
    },
    toastFocus() {
        setTimeout(() => {
            let elem = document.getElementsByClassName("toast")
            elem = elem[elem.length-1]
            elem.focus()
        }, 100)
    },
  },
  created() {
      document.title = "Change License Expiration Date - TEST ONLY - Body Art"
  }
}
</script>

<style>
</style>